var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 7.99984C9.47329 7.99984 10.6666 6.8065 10.6666 5.33317C10.6666 3.85984 9.47329 2.6665 7.99996 2.6665C6.52663 2.6665 5.33329 3.85984 5.33329 5.33317C5.33329 6.8065 6.52663 7.99984 7.99996 7.99984ZM7.99996 9.33317C6.21996 9.33317 2.66663 10.2265 2.66663 11.9998V12.6665C2.66663 13.0332 2.96663 13.3332 3.33329 13.3332H12.6666C13.0333 13.3332 13.3333 13.0332 13.3333 12.6665V11.9998C13.3333 10.2265 9.77996 9.33317 7.99996 9.33317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson24Dp);
export default __webpack_public_path__ + "static/media/person_24dp.4acdb8003547c75844485d1aa3ce27b6.svg";
export { ForwardRef as ReactComponent };